define('extensions/i18n/knockout.lDate',[
    'lib/knockout'
], function (ko) {
    'use strict';

    /**
     * <p>Binding handler for rendering localized date strings. Parameters are:</p>
     * <dl>
     *  <dt>date</dt>
     *  <dd>the date to format in the current locale. Undefined is allowed.</dd>
     *  <dt>format</dt>
     *  <dd>the moment.js format to use. Default is 'LLLL'. More explaination here: {http://momentjs.com/docs/#/displaying/format/}</dd>
     *  <dt>locale</dt>
     *  <dd>the locale to use. Default is current locale</dd>
     *</dl>
     * <pre class="prettyprint">
     * &lt;span data-bind="lDate: {date: new Date(), format: "LLLL"}"&gt;
     * &lt;/span&gt;
     * </pre>
     *
     * @exports extensions/i18n/knockout-lDate
     */
    ko.bindingHandlers.lDate = {
        init: function () {},
        update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
            var date,
                data,
                format,
                locale,
                dateInfo = ko.utils.unwrapObservable(valueAccessor());

            var defaultFormat = "LLLL";
            // if traditional Chinese, change format due to rendering issues
            if (ko.i18n.getLocale() === 'zh-TW') {
                defaultFormat = "LLL";
            }

            if (dateInfo && dateInfo instanceof Date) {
                date = dateInfo;
                format = defaultFormat;
                data = viewModel;

                element.innerHTML = ko.i18n.formatDate(date,
                                               format,
                                               locale);
            } else if (dateInfo && dateInfo.date) {
                date = ko.unwrap(dateInfo.date);
                format = dateInfo.format || defaultFormat;
                data = dateInfo.data || viewModel;
                locale = dateInfo.locale;

                if (!/[a-zA-Z]/.test(date) && !/\d/.test(date)) {
                    // if we just have a character that we don't want to localize (such as '-')
                    element.innerHtml = date;
                } else {
                    element.innerHTML = ko.i18n.formatDate(date,
                               format,
                               locale);
                }

            }
        }
    };

    return ko.bindingHandlers.lDate;
});

